'use es6';

import { Record } from 'immutable';
export default Record({
  campaigns: null,
  aggregateFunnel: null
});